// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"c4914c27394b55a75a4e","293":"cf141205e79d4711e001","518":"1f08895356fba92d2e89","779":"338ec6313970360dfc91"}[chunkId] + ".js";
};